module.exports = __webpack_public_path__ + "img/container-2-v.bcecea5d.png";